import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  userLogin,
  resetErrorMessages,
} from "../../redux/features/user.features";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import packageInfo from "../../../package.json";
import spinner from '../../assets/Spinner-1s-200px.svg'

const initialState = {
  email: "",
  password: "",
};

const Login = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let from = location.state?.from?.pathname || "/";
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userReducer);
  const { errorMessage, user, isLogin } = userState;
  const [values, setValues] = useState(initialState);
  const [error, setError] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setError(null);
    dispatch(resetErrorMessages());
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      console.log("User pressed: ", event.key);

      if (event.key === "Enter") {
        event.preventDefault();

        // 👇️ your logic here

        validate();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [values]);

  useEffect(() => {
    if (isLogin) {
      setShowSuccess(true);
      setTimeout(() => {
        if (user.role === "admin") navigate("/", { replace: true });
        else navigate("/", { replace: true });
      }, 1000);
     
    }
  }, [isLogin]);

  const validate = async () => {
    if (!values) {
      setError("Enter all required values");
    } else if (!values.email) {
      setError("email is required");
    } else if (!values.password) {
      setError("password is required");
    } else {
      dispatch(userLogin(values));
      setError(null);

      dispatch(resetErrorMessages());
    }
  };

  return (
    <div
      className="flex w-full h-full justify-center items-center fixed"
      style={{ backgroundColor: "var(--main-bg-dark)" }}
    >
      <div className=" w-3/12 h-2/6 items-center justify-center  flex flex-col">
        <h5 className="text-white p-3 text-3xl font-extrabold uppercase mx-2">
          Login
        </h5>
        <input
          onChange={handleChange}
          value={values.email}
          type="email"
          name="email"
          className="bg-gray-900 w-full p-3 mx-2  text-gray-400 font-extrabold"
          placeholder="Email"
        />
        <input
          className="bg-gray-900 w-full p-3 mx-2 text-gray-400 font-extrabold"
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleChange}
          value={values.password}
          style={{ margin: 10 }}
        />
        <div className="m-3 flex justify-between items-center w-full flex-col">
          <button
            // onClick={() => dispatch(userLogin(values))}

            onClick={() => validate()}
            className="text-white w-full p-3 rounded   cursor-pointer"
            style={{ background: "var(--main-color)" }}
          >
            <p>Login</p>
          </button>
        </div>
        {errorMessage && errorMessage !== "" && (
          <div className="my-5  flex justify-center items-center p-5 bg-red-500 rounded text-white">
            {errorMessage}
          </div>
        )}
        {error !== "" && error && (
          <div className="my-5  flex justify-center items-center p-5 bg-red-500 rounded text-white">
            {error}
          </div>
        )}
        {!error &&
          !errorMessage &&
          showSuccess &&
          user &&
          user.email !== "" && (
            <div className="my-5  flex justify-center items-center p-5 bg-green-500 rounded text-white">
              Welcome {user.email}
              <img style={{width:50}} src={spinner} alt="spinner"></img>
             
            </div>
          )}
        <div className=" flex flex-col  items-center text-white p-3 bg-blue-500 rounded mt-8">
          <h3>Environment : {process.env.REACT_APP_RELEASE_TYPE}</h3>
          <h4 className="mx-2">Build version {packageInfo.version}</h4>
        </div>
      </div>
    </div>
  );
};

export default Login;
